const css = require("./assets/css/frame.styl");
const platformCheck = checkPlatform();

function checkPlatform() {
    if (navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)) {
        if (navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == "micromessenger") {
            return 'wx'
        } else {
            return 'mobile';
        }
    } else {
        return "pc";
    }
}
// console.log(css)
let buyFrameSrc = '';
if (document.location.hostname.indexOf('10.') > -1) {
    buyFrameSrc = 'http://'+document.location.hostname+':1234/';
} else if (document.location.host.indexOf('test.edrawsoft.cn') > -1) {
    buyFrameSrc = 'https://test.edrawsoft.cn/buy/pageframe/';
} else if (document.location.host.indexOf('www.edrawmax.cn') > -1) {
    buyFrameSrc = 'https://www.edrawmax.cn/testbuyframe/pageframe/';
} else {
    buyFrameSrc = 'https://www.edrawsoft.cn/pageframe/buyframe/';
}
// let buyFrameSrc = (document.location.host.indexOf('10.') > -1) ? 'http://10.10.3.20:1234/' : 'https://www.edrawsoft.cn/pageframe/buyframe/';


let urlParams = new URLSearchParams(location.search);
let other = !!urlParams.get('source') ? ("&source=" + urlParams.get('source')) : "";
other = other + (!!urlParams.get('catalogues') ? ("&catalogues=" + urlParams.get('catalogues')) : "");
other = other + (!!urlParams.get('trackorder') ? ("&trackorder=" + urlParams.get('trackorder')) : "");

{
    /* <div id="design-icon-1" class="cloud-1 buy-frame-icon"></div>
    <div id="design-icon-2" class="cloud-2 buy-frame-icon"></div>
    <div id="design-icon-3" class="cloud-3 buy-frame-icon"></div> */
}

function getHtmlFragment(query) {
    let closeColor = String(query.type) === '19' ? '#FFB2B2' : '#515151'
    return `
    <div class="${wrapperId}" id='${wrapperId + query.product + query.type}'>
        <div class="${closeId} buy-frame-icon" id='${closeId + query.product + query.type}'></div>
        <iframe src="${buyFrameSrc + '?product=' + query.product + "&type=" + query.type + "&token=" + query.token + "&id=" + query.id + (query.subtype ? ("&subtype=" + query.subtype) : "") + (query.extra ? ("&extra=" + query.extra) : "") + (!!other ? other : '')}" class='edraw-buy--frame' frameborder="0"></iframe>
    </div>
`;
}

/**
<svg class="${closeId}" id='${closeId + query.product + query.type}' xmlns="http://www.w3.org/2000/svg"
xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1024 1024" width="200" height="200">
<path
    d="M521.693867 449.297067L111.4112 39.0144a51.2 51.2 0 1 0-72.430933 72.362667l410.282666 410.3168-410.282666 410.3168a51.2 51.2 0 1 0 72.3968 72.3968l410.3168-410.282667 410.3168 410.282667a51.2 51.2 0 1 0 72.3968-72.362667l-410.282667-410.350933 410.282667-410.282667a51.2 51.2 0 1 0-72.3968-72.3968l-410.282667 410.282667z"
    fill="${closeColor}" />
</svg>
 */
const containerId = "edraw-buy";
const wrapperId = "edraw-buy--wrapper";
const closeId = "edraw-buy--close";

function checkMessage(query) {
    window.addEventListener('message', function (e) {
        // 监听子页面颜色的改变即发送的消息，设置div颜色
        // console.log("zct data",e.data)
        // console.log('message zct query.product:',query.product)
        var data = e.data;
        if (data.height && String(query.type) === String(data.height.type)) {
            document.getElementById(wrapperId + query.product + query.type).style.height = data.height.data;
        } else if (data.closeBtn) {
            document.getElementById(closeId + query.product + query.type).style.display = data.closeBtn
            // if(localStorage.getItem('preCloseBtnEle')&&(localStorage.getItem('preCloseBtnEle') != (closeId + query.product + query.type))){
            //     document.getElementById(localStorage.getItem('preCloseBtnEle')).style.display = "none";
            // }
            // localStorage.setItem('preCloseBtnEle',closeId + query.product + query.type);
            // console.log('zct closeBtn:',data.closeBtn)
        } else if (data.href) {
            window.href = data.href;
        } else if (data.console) {
            if (navigator.userAgent.match(/Android/i) ||
                navigator.userAgent.match(/webOS/i) ||
                navigator.userAgent.match(/iPhone/i) ||
                navigator.userAgent.match(/iPad/i) ||
                navigator.userAgent.match(/iPod/i) ||
                navigator.userAgent.match(/BlackBerry/i) ||
                navigator.userAgent.match(/Windows Phone/i)) {
                window.open("https://www.edrawsoft.cn/enterprise/");
            } else {
                if (document.getElementById("wondershare_chatbot_iframe")) {
                    document.getElementById("wondershare_chatbot_iframe").contentWindow.document.getElementsByClassName('bubble')[0].click()
                } else {
                    window.open("https://www.edrawsoft.cn")
                }
            }
        } else if (data.showFrame) {
            document.getElementById(containerId + query.product + query.type).style.visibility = data.showFrame;
        } else if (data.clearQuery) {
            location.href = location.href.split('?')[0];
        } else if (data.setDesign) {
            document.querySelectorAll('.buy-frame-icon').forEach((item) => {
                item.classList.add('active')
            })
        }
        removeEventListener("message", null, false);
    }, false)
}

function isIE() {
    if (!!window.ActiveXobject || "ActiveXObject" in window) {
        return true;
    } else {
        return false;
    }
}
/**
 * 判断是否是IE11
 */
function isIE11() {
    if ((/Trident\/7\./).test(navigator.userAgent)) {
        return true;
    } else {
        return false;
    }
}
// 显示购买frame
function initBuy(query) {
    // $edChannel && $edChannel.getChannel().then(function(channel){
    //     channel && (other = other + "&from="+ channel);
    // }).catch(function(error){
    //     console.log(error)
    // })
    // console.log(urlParams.get('channel'))
    if (urlParams.get('channel')) {
        (other = other + "&from=" + urlParams.get('channel'));
    }
    //加样式
    let container = document.getElementById(containerId + query.product + query.type);

    if (isIE() || isIE11()) {
        if (container) { container.removeNode(true); }
    } else {
        if (container) { container.remove(); }
    }
    // if (container) {
    //     container.style.visibility = "visible";
    //     return;
    // }
    const d_code = urlParams.get('coupon');
    d_code && (other = other + "&d_code=" + d_code);
    let nodeEle = document.createElement("div");
    //     styleEle = document.createElement("style");
    // styleEle.textContent = css;
    // document.head.appendChild(styleEle);
    //加html
    nodeEle.setAttribute("id", containerId + query.product + query.type);
    nodeEle.style.visibility = "visible";
    nodeEle.className = containerId;
    nodeEle.innerHTML = getHtmlFragment(query);
    document.body.appendChild(nodeEle);
    checkMessage(query);
    //绑定close事件
    let closeEle = document.getElementById(closeId + query.product + query.type);
    closeEle.addEventListener("click", () => {
        if (urlParams.get('buySuccess')) {
            location.href = location.href.split('?')[0];
        }
         else {
            nodeEle.style.visibility = "hidden";
        }
    })
}
// 当url携带type的时候直接展示相应的购买弹窗
function showBuyFrame(product) {
    const type = urlParams.get('type');
    const buySuccess = urlParams.get('buySuccess');
    const subtype = urlParams.get('subtype');
    if (!!type && !buySuccess) {
        const q = urlParams.get('q') || "1";
        // const from = urlParams.get('from') || urlParams.get('from') || "web";
        const platform = urlParams.get('platform') || "";
        const pay = urlParams.get('pay') || "2";
        let query = {
            product: product,
            type: type
        };
        if (subtype) query.subtype = subtype;
        q && (other = other + "&q=" + q);
        // from && (other = other + "&from="+ from);
        platform && (other = other + "&platform=" + platform);
        pay && (other = other + "&pay=" + pay);
        initBuy(query);
    }
}

function checkAliPay(query) {
    // const type = urlParams.get('type');
    const buySuccess = urlParams.get('buySuccess');
    if (!!buySuccess) {
        const quantity = urlParams.get('quantity') || "1";
        const payerEmail = urlParams.get('payerEmail');
        const orderId = urlParams.get('orderId');
        const buyer_email = urlParams.get('buyer_email') || "2";
        const subtype = urlParams.get('subtype') || "";
        buySuccess && (other = other + "&buySuccess=" + buySuccess);
        subtype && (other = other + "&subtype=" + subtype);
        quantity && (other = other + "&quantity=" + quantity);
        payerEmail && (other = other + "&payerEmail=" + payerEmail);
        orderId && (other = other + "&orderId=" + orderId);
        buyer_email && (other = other + "&buyer_email=" + buyer_email);
        initBuy(query);
    }
}

function isMobile() {
    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
        // console.log('移动端');
        // this.isPc=false;
        return true;
    } else {
        // console.log('pc端');
        // this.isPc=true;
        return false;
    }

}
function isWeiXin() {
    var ua = window.navigator.userAgent.toLowerCase();    // 该属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息
    //通过正则表达式匹配ua中是否含有MicroMessenger字符串
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
    } else {
        return false;
    }
}
// window.addEventListener("load", function() {
//     //广告渠道标志
//     $edChannel.getChannel().then(function(channel){
//         channel && (other = other + "&from="+ channel);
//     })
// })

export default {
    // query对象示例{product：'max',type：1}
    // 若为需要登录的产品比如终身订阅版，query则需要附加token以及id
    // 用于展示相应的购买弹窗
    showIframe(query, o) {
        o && (other = other + o);
        initBuy(query);
    },
    // product字符串示例'max'
    // 用于初始化页面的时候检测页面url所带参数是否有type，有则直接获取url所带参数来直接展示相应的购买弹窗
    showBuyFrame(product) {
        showBuyFrame(product);
    },
    checkAliPay,
    checkWXRedirect(redirect_url) {
        if (platformCheck === 'wx') {
            if (!urlParams.get("code")) {
                if ((isMobile() || isWeiXin()) && navigator.userAgent.indexOf('Chrome') > -1) {
                    window.location.replace("https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx01c227949906085b&redirect_uri=" + encodeURIComponent(redirect_url) + "&response_type=code&scope=snsapi_base&state=123#wechat_redirect");
                } else {
                    location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx01c227949906085b&redirect_uri=" + encodeURIComponent(redirect_url) + "&response_type=code&scope=snsapi_base&state=123#wechat_redirect"
                }

            } else {
                const code = urlParams.get("code");
                code && (other = other + "&code=" + code);
                return true;
            }
        }
    }
}
